module.exports = __webpack_public_path__ + "static/a-business-executive-explains-the-titan-advantage-index-885db1327190448deadb4a847f746a39.jpg";